import { render, staticRenderFns } from "./IOUAndCertificates.vue?vue&type=template&id=7863f629&"
import script from "./IOUAndCertificates.vue?vue&type=script&lang=ts&"
export * from "./IOUAndCertificates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports